module.exports = __webpack_public_path__ + "static/media/s_v10_t4.c8c44f4b.mp3";